import Mmenu from 'mmenu-js';
import { clearAllBodyScrollLocks } from 'body-scroll-lock';
import BaseFeature from '../../foundation/base/base';

class ToggleMenu extends BaseFeature {
	constructor(element) {
		super(element);

		this.initDomCache();

		this.el = element;
		this.ticking = false;
		this.toggleMenu = this.el;
		this.body = window.features.dom.body;
		this.mobileCloseBtn = document.querySelector('[data-js="mobileCloseBtn"]');
		this.serviceMenu = document.querySelector('[data-js="serviceMenu"]');
		this.headerContainer = document.querySelector('.o-header--top .o-header--container');
		this.mobileNavArrow = document.querySelector('.mm-btn_next');


		this.addClick();
		this.addTheme();
	}

	addClick() {
		// Initilizing the plugin
		this.menu = new Mmenu(this.el, {
			navbar: { title: ' ' },
			offCanvas: {
				blockUI: false
			}
		});
		this.api = this.menu.API;

		document.querySelector('.m-menu-list__close-btn-link').addEventListener('click', () => {
			this.el.classList.remove('is-open');
			clearAllBodyScrollLocks();
		});
		if (document.querySelector('.mm-btn_next')) {
			document.querySelector('.mm-btn_next').setAttribute('tabindex', '-1');
		}

		// Appending service menu into mobile menu
		if (this.serviceMenu) {
			const mq = window.matchMedia('(max-width: 1247px)');
			if (mq.matches) {
				setTimeout(() => {
					this.el.appendChild(this.serviceMenu);
				}, 300);
			} else {
				this.headerContainer.prepend(this.serviceMenu);
			}
			// RESIZE Appending service menu into mobile menu
			window.addEventListener('resize', () => {
				if (mq.matches) {
					setTimeout(() => {
						this.el.appendChild(this.serviceMenu);
					}, 300);
				} else {
					this.headerContainer.prepend(this.serviceMenu);
				}
			});
		}

		/**
		 * Open the active panel and select current menu item
		 */
		this.activePanel = this.el.querySelector('.is-active') ? this.el.querySelector('.is-active').closest('.mm-panel') : null;
		this.currentItem = this.el.querySelector('.is-current');

		if (this.activePanel) {
			this.api.openPanel(this.activePanel);
		}

		if (this.currentItem) {
			this.api.setSelected(this.currentItem);
		}
		setTimeout(() => {
			document.querySelector('.mm-menu');
		}, 300);
	}

	addTheme() {
		this.menu.node.menu.classList.add('mm-menu_theme-dark');
	}
}

export default ToggleMenu;
